<template>
    <div class="py-4">
        <modal-filter :onfilter="onfilter" :filter="filter" @onclose="onfilter = false" @onfilter="ONFILTER()" :exclude="[]"/>
        <modal-delete v-if="ondelete" :ondelete="ondelete" :id="id" @onclose="ondelete = false" @onreload="ONFILTER()"/>
        <modal-reload v-if="onreload" :onreload="onreload" :item="item" @onclose="onreload = false" @onreload="FRESH"/>
        <header>
            <div class="container-fluid">
                <div class="pb-4">
                    <div class="row align-items-end">
                        <div class="col-sm col-12">
                            <h1 class="h2 ls-tight">Rutas de entrega</h1>
                        </div>
                        <div class="col-sm-auto col-12 mt-4 mt-sm-0">
                            <div class="hstack gap-2 justify-content-sm-end">
                                <router-link :to="{ name: 'DeliverRouteCreate' }">
                                    <button type="button" class="btn btn-h btn-primary px-3">
                                        <span>Crear</span>
                                    </button>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main>
            <div class="container-fluid">
                <div class="vstack gap-4">
                    <div class="d-flex flex-column flex-md-row gap-3 justify-content-between">
                        <form class="d-flex gap-3 row" @submit.prevent="FILTER()">
                            <div>
                                <button @click="onfilter = true" type="button" class="btn btn-h px-3 btn-neutral">
                                    <i class="bi bi-funnel me-2"></i>
                                    <span>Filtro</span>
                                    <span class="vr opacity-20 mx-3"></span>
                                    <span class="text-xs text-primary">{{ count_filter }}</span>
                                </button>
                            </div>
                            <div>
                                <button @click="SORT()" type="button" class="btn btn-h px-3 btn-neutral">
                                    <i class="me-2" :class="filter.sortDesc == 'ASC' ? 'bi bi-sort-alpha-up' : 'bi bi-sort-alpha-down-alt'"></i>
                                    <span>{{ filter.sortDesc }}</span>
                                </button>
                            </div>
                            <div class="col-md-2 px-0">
                                <div class="input-group input-group-sm input-group-inline">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text pe-2 text-sm"><i class="fa-solid fa-hashtag"></i></span>
                                    </div>
                                    <input type="text" class="form-control" @keypress="NUMBER" placeholder="Buscar No." v-model="filter.search">
                                </div>
                            </div>
                            <div>
                                <button type="submit" class="btn btn-h px-3 btn-primary">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="loading == 'filter'">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Buscar</span>
                                </button>
                            </div>
                            <div>
                                <button type="button" class="btn btn-h px-3 btn-danger" @click="CLEAR()">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="loading == 'clear'">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Limpiar</span>
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="card">
                        <div class="card-header bg-white">
                            <h5 class="me-auto">Listado</h5>
                        </div>
                        <div class="card-body p-0">
                            <template>
                                <v-data-table  class="elevation-1"
                                    :headers="headers"
                                    :items="loading == 'table' || loading == 'sort' || loading == 'filter' || loading == 'clear' ? [] : items.data"
                                    :options.sync="options"
                                    :server-items-length="items.total"
                                    :loading="loading == 'table' || loading == 'sort' || loading == 'filter' || loading == 'clear'"
                                    :footer-props="{
                                        'items-per-page-options': [5, 10, 50, 100]
                                    }">
                                    <template v-slot:[`item.state_id`]="{ item }">
                                        <span class="badge badge-secondary badge-pill" v-if="item.state_id == 26">Entregada al chofer</span>
                                        <span class="badge badge-secondary badge-pill" v-else>Creada</span>
                                    </template>
                                    <template v-slot:[`item.date`]="{ item }">
                                        {{ item.date | DATE }}
                                    </template>
                                    <template v-slot:[`item.update`]="{ item }">
                                        <v-tooltip top  v-if="globalViewOption('DeliverRouteUpdate') && item.state_id == 25">
                                            <template v-slot:activator="{ on, attrs }">
                                                <a v-bind="attrs" v-on="on">
                                                    <router-link :to="{ name: 'DeliverRouteUpdate', params: { id: item.id } }"
                                                        class="btn btn-primary btn-m">
                                                        <small><i class="bi bi-pencil-square"></i></small>
                                                    </router-link>
                                                </a>
                                            </template>
                                            <small>Editar</small>
                                        </v-tooltip>
                                        <button class="btn btn-primary btn-m" disabled v-else>
                                            <small><i class="bi bi-pencil-square"></i></small>
                                        </button>
                                    </template>
                                    <template v-slot:[`item.packages`]="{ item }">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <a v-bind="attrs"
                                                    v-on="on">
                                                    <router-link
                                                        :to="{ name: 'DeliverRoutePackages', params: { id: item.id } }"
                                                        class="btn btn-orange btn-m">
                                                        <small><i class="fa-solid fa-cubes"></i></small>
                                                    </router-link>
                                                </a>
                                            </template>
                                            <small>Abrir</small>
                                        </v-tooltip>
                                    </template>
                                    <template v-slot:[`item.delete`]="{ item }">
                                        <v-tooltip top v-if="globalViewOption('DeliverRouteDelete') && item.state_id == 25">
                                            <template v-slot:activator="{ on, attrs }">
                                                <button @click="DELETE(item.id)"
                                                    type="button"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    class="btn btn-danger btn-m">
                                                    <small><i class="bi bi-trash3"></i></small>
                                                </button>
                                            </template>
                                            <small>Eliminar</small>
                                        </v-tooltip>
                                        <button class="btn btn-danger btn-m" disabled v-else>
                                            <small><i class="bi bi-trash3"></i></small>
                                        </button>
                                    </template>
                                    <template v-slot:[`item.print`]="{ item, index }">
                                        <div class="d-flex gap-3">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <button @click="PRINT(item.id, index)"
                                                        type="button"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        class="btn btn-neutral btn-m">
                                                        <small class="d-flex justify-content-center align-items-center">
                                                            <div class="spinner-border spinner-border-sm mb-0" role="status" v-if="loading == 'print' && loadings.filter(e => e == index).length == 1">
                                                                <span class="sr-only">Loading...</span>
                                                            </div>
                                                            <i class="bi bi-printer" v-else></i>
                                                        </small>
                                                    </button>
                                                </template>
                                                <small>Imprimir</small>
                                            </v-tooltip>
                                        </div>
                                    </template>
                                    <template v-slot:[`item.deliver`]="{ item }">
                                        <div class="d-flex">
                                            <div v-if="item.state_id == 26" class="mr-2">
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <button @click="ACTION(item, true)"
                                                            type="button"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            :disabled="item.state_id == 27"
                                                            class="btn btn-m btn-danger">
                                                            <small><i class="fa-solid fa-truck-fast fa-flip-horizontal"></i></small>
                                                        </button>
                                                    </template>
                                                    <small>Devolver</small>
                                                </v-tooltip>
                                            </div>
                                            <div>
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <button @click="ACTION(item)"
                                                            type="button"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            :disabled="item.state_id == 27"
                                                            class="btn btn-m" :class="item.state_id == 25 ? 'btn-info' : 'btn-success'">
                                                            <small><i :class="item.state_id == 25 ? 'fa-solid fa-truck-fast' : 'fa-solid fa-check'"></i></small>
                                                        </button>
                                                    </template>
                                                    <small>{{ item.state_id == 25 ? 'Entregar' : 'Completar' }}</small>
                                                </v-tooltip>
                                            </div>
                                        </div>
                                    </template>
                                </v-data-table>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
import ModalFilter from './modals/Filter'
import ModalDelete from './modals/Delete'
import ModalReload from './modals/Reload'
export default {
    components: { ModalFilter, ModalDelete, ModalReload },
    data() {
        return {
            headers: [
                { text: 'No.', value: 'id', sortable: false },
                { text: 'Ruta', value: 'route.full_name', sortable: false },
                { text: 'Fecha Programada', value: 'date', sortable: false },
                { text: 'Chofer', value: 'driver.name', sortable: false },
                { text: 'Unidad', value: 'unit.name', sortable: false },
                { text: 'Estado', value: 'state_id', sortable: false },
                { text: 'Editar', value: 'update', sortable: false },
                { text: 'Paquetes', value: 'packages', sortable: false },
                { text: 'Eliminar', value: 'delete', sortable: false },
                { text: 'Imprimir', value: 'print', sortable: false },
                { text: 'Entregar', value: 'deliver', sortable: false }
            ],
            items: {
                data: [],
                total: 0,
                to: 0
            },
            cancelToken: null,
            loading: '',
            loadings: [],
            options: {},
            filter: {
                search: '',
                sortBy: 'id',
                sortDesc: 'DESC',
            },
            onfilter: false,
            ondelete: false,
            onreload: false,
            id: null,
            item: null,
            count: 0,
        }
    },
    computed: {
        count_filter: function(){
            let count = 0;
            let vue = this
            Object.entries(vue.filter).forEach((e) => {
                if(e[0] != 'sortBy' && e[0] != 'sortDesc' && e[0] != 'search' && e[0] != 'loading'){
                    if(typeof e[1] == 'object'){
                        if(e[1]){
                            if(e[1].length > 0){
                                count++
                            }
                        }
                    }else{
                        if(e[1]){
                            count++
                        }
                    }   
                }
            })
            return count;
        }
    },
    methods: {
        INIT: function () {
            let vue = this
            const source = axios.CancelToken.source()
            vue.cancelToken = source
            const { page, itemsPerPage } = vue.options
            let query = {
                page: page,
                itemsPerPage: itemsPerPage,
            }
            Object.entries(vue.filter).forEach((e) => {
                query[e[0]] = e[1]
            })
            axios({
                url: '/deliver-routes',
                method: 'GET',
                params: query,
                cancelToken: source.token,
            })
                .then((resp) => {
                    vue.items = resp.data
                    vue.loading = ''
                })
                .catch((err) => {
                    if (err.code !== 'ERR_CANCELED') {
                        if (err.response.status === 402) {
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                        vue.loading = ''
                    }
                })
        },
        SORT: function () {
            let vue = this
            if (vue.cancelToken) {
                vue.cancelToken.cancel("Solicitud cancelada");
            }
            vue.filter.sortDesc = vue.filter.sortDesc == 'ASC' ? 'DESC' : 'ASC'
            vue.loading = 'sort'
            vue.INIT()
        },
        ONFILTER: function(){
            let vue = this
            vue.onfilter = false
            vue.loading = 'table'
            if (vue.cancelToken) {
                vue.cancelToken.cancel("Solicitud cancelada");
            }
            vue.INIT()
        },
        FILTER: function () {
            let vue = this
            let count = 0
            if (vue.filter.search.length > 0) {
                count++
            }
            if (count > 0) {
                vue.loading = 'filter'
                if (vue.cancelToken) {
                    vue.cancelToken.cancel("Solicitud cancelada");
                }
                vue.INIT()
            }
        },
        CLEAR: function () {
            let vue = this
            vue.loading = 'clear'
            vue.filter = {
                sortBy: 'id',
                sortDesc: 'DESC',
            }
            if (vue.cancelToken) {
                vue.cancelToken.cancel("Solicitud cancelada");
            }
            vue.INIT()
        },
        DELETE: function (id) {
            let vue = this
            vue.id = id
            vue.ondelete = true
        },
        PRINT: function(print, index){
            let vue = this
            vue.loading = 'print'
            if(vue.loadings.filter(e => e == index).length == 0){
                vue.loadings.push(index)
                axios({url: '/print/deliver-route/' + print + '/packages', method: 'GET', responseType: 'blob' })
                .then((response) => {
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(response.data)
                    link.target = '_blank'
                    link.rel = "noopener"
                    link.click()
                })
                .finally((resp)=>{
                    vue.loadings.splice(vue.loadings.findIndex(e => e == index), 1)
                    vue.loading = ''
                })
            }
        },
        ACTION: function(item, revert = false){
            let vue = this
            vue.item = item
            vue.item.revert = revert
            vue.onreload = true
        },
        FRESH: function(item){
            let vue = this
            vue.onreload = false
            let index = vue.items.data.findIndex(e => e.id == item.id)
            if(index != -1){
                if(vue.items.data[index].id == item.id){
                    vue.items.data[index].state_id = item.state_id
                }
            }
        }
    },
    watch: {
        options: {
            handler() {
                if (this.cancelToken) {
                    this.cancelToken.cancel("Solicitud cancelada");
                }
                this.loading = 'table'
                this.INIT()
            },
            deep: true
        }
    }
}
</script>
